import { Route, Sparkles, IndianRupee, ShieldCheck, Phone } from "lucide-react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main className="min-h-screen grid lg:grid-cols-2 bg-slate-50" data-testid="login-page">
      <div className="flex flex-col justify-center px-8 sm:px-16 lg:px-24 py-16">
        <div className="flex items-center gap-3 mb-10">
          <img src="/teztrips-logo.webp" alt="Teztrips" className="h-16 w-auto" data-testid="login-brand-logo" />
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-slate-900 leading-[1.1] tracking-tight">
          Domestic India taxi bookings, <span className="text-blue-600">built for travel agents.</span>
        </h1>
        <p className="mt-5 text-base md:text-lg text-slate-600 max-w-md leading-relaxed">
          Plan multi-city trips, generate AI itineraries, and get all-India taxi quotations from a single B2B dashboard.
        </p>
        <div className="mt-10">
          <button
            data-testid="google-login-btn"
            onClick={handleLogin}
            className="inline-flex items-center gap-3 bg-slate-900 hover:bg-slate-800 text-white font-medium px-7 py-3.5 rounded-full transition-all hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24"><path fill="#EA4335" d="M12 5.04c1.62 0 3.06.56 4.2 1.64l3.12-3.12C17.46 1.8 14.96.75 12 .75 7.4.75 3.44 3.4 1.61 7.26l3.66 2.84C6.16 7.31 8.83 5.04 12 5.04z"/><path fill="#4285F4" d="M23.25 12.26c0-.79-.07-1.54-.19-2.26H12v4.51h6.32c-.29 1.48-1.14 2.73-2.4 3.58l3.66 2.84c2.15-1.99 3.67-4.92 3.67-8.67z"/><path fill="#FBBC05" d="M5.28 14.29a7.2 7.2 0 0 1 0-4.58L1.62 6.87a11.26 11.26 0 0 0 0 10.26l3.66-2.84z"/><path fill="#34A853" d="M12 23.25c3.04 0 5.6-1 7.46-2.72l-3.66-2.84c-1.02.69-2.33 1.1-3.8 1.1-3.17 0-5.84-2.27-6.73-5.29l-3.66 2.84c1.83 3.86 5.79 6.91 10.39 6.91z"/></svg>
            Continue with Google
          </button>
          <p className="mt-4 text-xs text-slate-500">Access for registered travel agents & fleet admins.</p>
          <p className="mt-2 text-xs text-slate-500 inline-flex items-center gap-1.5" data-testid="login-contact"><Phone className="w-3.5 h-3.5 text-blue-600" /> Teztrips Support: <b className="text-slate-700">+91 70808 05766</b></p>
        </div>
        <div className="mt-14 grid grid-cols-2 gap-x-8 gap-y-5 max-w-md">
          {[
            { icon: Route, t: "Multi-city routing", d: "City + nights matrix" },
            { icon: Sparkles, t: "AI itineraries", d: "Editable day plans" },
            { icon: IndianRupee, t: "B2B quotations", d: "Admin-rated pricing" },
            { icon: ShieldCheck, t: "Payment tracking", d: "Advance & balance ledger" },
          ].map(({ icon: Icon, t, d }) => (
            <div key={t} className="flex items-start gap-3">
              <Icon className="w-5 h-5 text-amber-600 mt-0.5 shrink-0" />
              <div>
                <div className="text-sm font-semibold text-slate-900">{t}</div>
                <div className="text-xs text-slate-500">{d}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="hidden lg:block relative">
        <img
          src="https://images.pexels.com/photos/5966915/pexels-photo-5966915.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600"
          alt="Indian highway journey"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-900/35" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="font-heading text-2xl font-bold">Golden Triangle to Kerala — one platform.</div>
          <div className="text-sm text-white/80 mt-1">Sedan · Ertiga · Innova Crysta · Tempo Traveller</div>
        </div>
      </div>
    </main>
  );
}
